import { useState } from 'react';

export const useModal = () => {
    const [modals, setModals] = useState({});
    const showModal = (id) => {
      setModals((prev) => ({ ...prev, [id]: true }));
    };
    const hideModal = (id) => {
      setModals((prev) => ({ ...prev, [id]: false }));
    };
    const isModalOpen = (id) => !!modals[id];
    return {
      showModal,
      hideModal,  
      isModalOpen,
    };
  };